import { useEffect, useState } from 'react'
import Link from '@bigyellow/components/ActiveLink'
import { Nav, Navbar } from 'react-bootstrap'
import * as Urls from '@bigyellow/routes'
import { PATHNAME } from '@bigyellow/routes'
import StoreItem from '@bigyellow/components/Store'
import {
    CustomerType,
    getAccountType,
    getActiveAccount,
    getActiveStore,
    getFirstAccountType,
    useCustomer
} from '@bigyellow/libs/customer'
import { getItem } from '@bigyellow/libs/storage'

const LeftSideMenu = ({sideMenu, canCheckin, overrideSideMenuLinks}) => {

    const [userData, setUserData] = useState();
    const [activeStore, setActiveStore] = useState();

    const [customerType, setCustomerType] = useState(CustomerType.DOMESTIC);
    //const [userCanCheckin, setUserCanCheckin] = useState(canCheckin);

    const {customer} = useCustomer();

    useEffect(async () => {

        const user = await getItem('user');
        setUserData(user);

        let newActiveStore =await getActiveStore();
        setActiveStore(newActiveStore);
        try {
            const activeAccount = await getActiveAccount();
            setCustomerType(getAccountType(activeAccount));
        } catch (e) {
            setCustomerType(getFirstAccountType(user));

        }


    }, []);

    const isShowStoreMode = () => {
        return (window.location.pathname === PATHNAME)
    }
    const canShowPersonalInfoLink = () => {

        return canCheckin || (overrideSideMenuLinks && overrideSideMenuLinks.personalInfo);
    }
    const getPersonalInfoLinkUrl = () => {
        return overrideSideMenuLinks && overrideSideMenuLinks.personalInfo ? overrideSideMenuLinks.personalInfo.url : Urls.PERSONAL_INFO;
    }

    const getPersonalInfoTitle = () => {
        return overrideSideMenuLinks && overrideSideMenuLinks.personalInfo ? overrideSideMenuLinks.personalInfo.title : (customerType === 'DOM' ? 'Personal Information' : 'Company Information');
    }


    const canShowEndStorageLink = () => {
        return overrideSideMenuLinks && overrideSideMenuLinks.endStorageLink && overrideSideMenuLinks.endStorageLink.hide === false
    }

    const canShowDefaultCheckinLinks = () => {

        return !overrideSideMenuLinks && canCheckin
    }

    return (
        <>
            <div
                className={`sidemenu-area sidemenu-light ${
                    sideMenu ? 'sidemenu-toggle' : ''
                }`}
            >
                <Navbar
                    className={`sidemenu ${
                        sideMenu ? 'hide-nav-title' : ''
                    }`}
                >
                    <Navbar.Collapse>
                        <Nav>
                            
                            <Link href={Urls.HOME} activeClassName="active">
                                <a className="nav-link" style={{marginBottom: '50px'}}>
                                    <i className="nav-icon icofont-home"/>
                                    <span className="title">My Account</span>
                                </a>
                            </Link>

                            {isShowStoreMode() && userData && userData.customerAccounts.map((item, key) => (
                                  <StoreItem
                                    account={item}
                                    key={key}
                                    textonly={true}
                                  />
                            ))}

                            {/*<Link href={Urls.CHECKIN} activeClassName="active">*/}
                            {/*    <a className="nav-link">*/}
                            {/*        <i className="nav-icon icon-checkin"/>*/}
                            {/*        <span className="title">Check-In Online</span>*/}
                            {/*    </a>*/}
                            {/*</Link>*/}


                            {(!isShowStoreMode()) && (
                                <>
                                    <div className="nav-heading">
                                        {/*<i className="nav-icon icofont-home"/>*/}
                                        <span className="title">{activeStore?.name}</span>
                                    </div>
                                    {canShowPersonalInfoLink() &&
                                        <Link
                                            href={getPersonalInfoLinkUrl()}
                                            activeClassName="active"
                                        >
                                            <a className="nav-link">
                                                <i className="nav-icon icon-personal-info"/>
                                                <span className="title">
                                            {getPersonalInfoTitle()}
                                        </span>
                                            </a>
                                        </Link>
                                    }
                                    {canShowDefaultCheckinLinks() &&
                                        <>
                                            <Link
                                                href={Urls.SECURITY_ACCESS}
                                                activeClassName="active"
                                            >
                                                <a className="nav-link">
                                                    <i className="nav-icon icon-security-access"/>
                                                    <span className="title">
                                            Security & Access
                                        </span>
                                                </a>
                                            </Link>
                                            <Link
                                                href={Urls.DIRECT_DEBIT}
                                                activeClassName="active"
                                            >
                                                <a className="nav-link">
                                                    <i className="nav-icon icon-direct-debit"/>
                                                    <span className="title">
                                        Direct Debit
                                        </span>
                                                </a>
                                            </Link>
                                            <Link
                                                href={Urls.CUSTOMER_LICENCE}
                                                activeClassName="active"
                                            >
                                                <a className="nav-link">
                                                    <i className="nav-icon icon-storage-licence"/>
                                                    <span className="title">
                                        Customer Licence
                                        </span>
                                                </a>
                                            </Link>
                                            <Link
                                                href={Urls.INVENTORY}
                                                activeClassName="active"
                                            >
                                                <a className="nav-link">
                                                    <i className="nav-icon icon-inventory"/>
                                                    <span className="title">Inventory</span>
                                                </a>
                                            </Link>
                                        </>
                                    }
                                    {canShowEndStorageLink() &&
                                        <Link
                                            href={overrideSideMenuLinks.endStorageLink.url}
                                            activeClassName="active"
                                        >
                                            <a className="nav-link">
                                                <i className="nav-icon icon-storage-licence"/>
                                                <span className="title">End my storage</span>
                                            </a>
                                        </Link>
                                    }
                                </>
                            ) }


                            {/*<Link*/}
                            {/*    href={Urls.SUPPORT}*/}
                            {/*    activeClassName="active"*/}
                            {/*>*/}
                            {/*    <a className="nav-link">*/}
                            {/*        <i className="nav-icon icon-bubble" />*/}
                            {/*        <span className="title">*/}
                            {/*            Support*/}
                            {/*        </span>*/}
                            {/*    </a>*/}
                            {/*</Link>*/}

                            <Link
                                href={Urls.WEBSITE}
                                activeClassName="active"
                            >
                                <a className="nav-link" style={{marginTop: '50px'}}>
                                    <i className="nav-icon icon-arrow-left"/>
                                    <span className="title">
                                            Back to website
                                        </span>
                                </a>
                            </Link>
                            <Link href={Urls.SETTINGS} activeClassName="active">
                                <a className="nav-link">
                                    <i className="nav-icon icon-settings"/>
                                    <span className="title">Settings</span>
                                </a>
                            </Link>
                            <Link
                                href={Urls.SIGNOUT}
                                activeClassName="active"
                            >
                                <a className="nav-link">
                                    <i className="nav-icon icon-logout"/>
                                    <span className="title">Sign out</span>
                                </a>
                            </Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        </>
    );
}

export default LeftSideMenu;
